import React, { useEffect, useRef ,useState} from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Button } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

mapboxgl.accessToken =
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

const FullParcelComponent = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

   // ✅ State for filters
  const [parcelData, setParcelData] = useState([]);
  const [filteredParcels, setFilteredParcels] = useState([]);
  
  const [showCountyFilter, setShowCountyFilter] = useState(false);
  const [countyFilter, setCountyFilter] = useState("All");
  const [countyOptions, setCountyOptions] = useState(["All"]);
  
  const [showOnlyVacant, setShowOnlyVacant] = useState(false);
  const [showOnlyListed, setShowOnlyListed] = useState(false);

  const FLOOD_ZONE_LEGEND = [
 
  { zone: "X", color: "#4CAF50", label: "X - Minimal Risk" },
  { zone: "AE", color: "#FF9800", label: "AE - High Risk + BFE" },
  { zone: "VE", color: "#E91E63", label: "VE - Coastal + BFE" },
  { zone: "A", color: "#2196F3", label: "A - High Risk (No BFE)" },
  { zone: "null", color: "#9fa2e7", label: "Unknown" },
 
 
 
];

  // ✅ Helper functions
  const normalizeListed = (raw) => {
    if (raw === null || raw === undefined) return "Not listed";
    const s = String(raw).trim().replace(/\s/g, " ");
    return s === "" ? "Not listed" : s;
  };

  const getListedRaw = (props = {}) => {
    return (
      props.listedsale ??
      props.listed_sale ??
      props.listedSale ??
      props.ListedSale ??
      props.listingsale ??
      props.listedsales ??
      null
    );
  };

  const isCountyActive = () => countyFilter && countyFilter !== "All";

  // ✅ Clear all filters
  const clearAllFilters = () => {
    setCountyFilter("All");
    setShowOnlyVacant(false);
    setShowOnlyListed(false);
    setShowCountyFilter(false);
    setFilteredParcels(parcelData);

    // Update map source
    try {
      if (mapRef.current?.getSource("parcels")) {
        mapRef.current.getSource("parcels").setData({
          type: "FeatureCollection",
          features: parcelData,
        });
      }
    } catch (e) {
      console.error("Error updating map source:", e);
    }
  };


  useEffect(() => {
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/light-v11",
    //   center: [-82.5929, 28.8917],
    //   zoom: 10,
       center: [-78.6443, 35.7877], // North Carolina approx center
      zoom: 10,
    });

    mapRef.current.on("load", async () => {
      try {
        console.log("Fetching GeoJSON...");
        // const res = await fetch("/assets/parcel/Fema_Flood_Parcel_Custom.geojson");
        //const res = await fetch("/assets/parcel/matched_fema_intersect.geojson");
        // const res = await fetch("/assets/parcel/northcarolina_parcels.geojson");
        // const res = await fetch("/assets/parcel/NCparcel_samp_test.geojson");
        // const res = await fetch("/assets/parcel/county_northcarolina_parcels.geojson");
        const res = await fetch("/assets/parcel/county_northcarolina_parcels.geojson");
        
        

        const geojson = await res.json();

        console.log("GeoJSON loaded:", geojson);
        const features = geojson.features || [];

          // ✅ Extract unique counties
        const counties = Array.from(
          new Set(
            features.map((f) => {
              const p = f.properties || {};
              return p.county || p.County || p.COUNTY || "Unknown";
            })
          )
        ).sort();
        setCountyOptions(["All", ...counties]);

        setParcelData(features);
        setFilteredParcels(features);


        // Add source
        mapRef.current.addSource("parcels", {
          type: "geojson",
          data: geojson,
        });


        mapRef.current.addLayer({
          id: "parcel-fill",
          type: "fill",
          source: "parcels",
          paint: {
            "fill-color": [
              "match",
              ["get", "parcel_custom_fema_flood"], // property from GeoJSON
              "X", "#4CAF50",
              "AE", "#FF9800",
              "VE", "#E91E63",
              "A", "#2196F3",
      /* default */ "#9fa2e7"
            ],
            "fill-opacity": 0.45,
          },
        });
        mapRef.current.addLayer({
          id: "parcel-outline",
          type: "line",
          source: "parcels",
          paint: {
            "line-color":  [
              "match",
              ["get", "parcelcustomfemaflood"], // property from GeoJSON
              "X", "#4CAF50",
              "AE", "#FF9800",
              "VE", "#E91E63",
              "A", "#2196F3",
      /* default */ "#9fa2e7"
            ],
            // "line-color": colorExpr,
            "line-width": 1.3,
          },
        });

      } catch (error) {
        console.error("Error while loading or adding layers:", error);
      }
    });

    return () => mapRef.current.remove();
  }, []);

// ✅ Apply filters
  useEffect(() => {
    const filtered = parcelData.filter((f) => {
      const props = f.properties || {};

      // County filter
      const county = props.county || props.County || props.COUNTY || "Unknown";
      const matchCounty = countyFilter === "All" || 
        String(county).toLowerCase() === String(countyFilter).toLowerCase();

      // Vacant filter
      const isVacant = props.is_vaccant === 1 || props.is_vaccant === "1";
      const matchVacant = !showOnlyVacant || isVacant;

      // Listed filter
      const listedVal = normalizeListed(getListedRaw(props));
      const matchListed = !showOnlyListed || listedVal !== "Not listed";

      return matchCounty && matchVacant && matchListed;
    });

    setFilteredParcels(filtered);

    // Update map source
    try {
      if (mapRef.current?.getSource("parcels")) {
        mapRef.current.getSource("parcels").setData({
          type: "FeatureCollection",
          features: filtered,
        });
      }
    } catch (e) {
      console.error("Error updating map source:", e);
    }
  }, [parcelData, countyFilter, showOnlyVacant, showOnlyListed]);


  return (
    <>

     {/* ✅ Filter Bar */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1000,
          background: "rgba(255, 255, 255, 0.95)",
          padding: "10px 15px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {/* County Filter */}
        <div style={{ position: "relative" }}>
          <Button
            variant="contained"
            endIcon={<ArrowDropDownIcon />}
            onClick={() => setShowCountyFilter(!showCountyFilter)}
            style={{
              textTransform: "none",
              background: isCountyActive() ? "#1c8f7d" : "transparent",
              color: isCountyActive() ? "#fff" : "#333",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              borderRadius: 6,
              fontSize: "12px",
            }}
          >
            {countyFilter === "All" ? "County" : `County - ${countyFilter}`}
          </Button>

          {/* County Dropdown */}
          {showCountyFilter && (
            <div
              style={{
                position: "absolute",
                top: "42px",
                left: 0,
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                borderRadius: "6px",
                zIndex: 999,
                padding: "6px 0",
                minWidth: "200px",
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {countyOptions.map((county) => (
                <div
                  key={county}
                  onClick={() => {
                    setCountyFilter(county);
                    setShowCountyFilter(false);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: countyFilter === county ? "#1c8f7d" : "transparent",
                    color: countyFilter === county ? "#fff" : "#000",
                    fontSize: 13,
                  }}
                >
                  {county}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Vacant Checkbox */}
        <div
          style={{
            color: "#007c6f",
            borderRadius: "20px",
            boxShadow: "none",
            border: "solid 1px #007c6f",
            padding: "6px 15px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
          onClick={() => setShowOnlyVacant(!showOnlyVacant)}
        >
          <input
            type="checkbox"
            checked={showOnlyVacant}
            onChange={(e) => setShowOnlyVacant(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#1c8f7d",
            }}
          />
          <span
            style={{
              fontSize: "12px",
              fontWeight: showOnlyVacant ? "600" : "500",
              color: showOnlyVacant ? "#1c8f7d" : "#333",
            }}
          >
            Vacant Only
          </span>
        </div>

        {/* Listed Sales Checkbox */}
        <div
          style={{
            color: "#007c6f",
            borderRadius: "20px",
            boxShadow: "none",
            border: "solid 1px #007c6f",
            padding: "6px 15px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
          onClick={() => setShowOnlyListed(!showOnlyListed)}
        >
          <input
            type="checkbox"
            checked={showOnlyListed}
            onChange={(e) => setShowOnlyListed(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#1c8f7d",
            }}
          />
          <span
            style={{
              fontSize: "12px",
              fontWeight: showOnlyListed ? "600" : "500",
              color: showOnlyListed ? "#1c8f7d" : "#333",
            }}
          >
            Listed for Sales
          </span>
        </div>

        {/* Clear Filters */}
        <Button
          variant="outlined"
          onClick={clearAllFilters}
          style={{
            textTransform: "none",
            borderColor: "#cfcfcf",
            color: "#333",
            fontSize: "12px",
          }}
        >
          Clear Filters
        </Button>
      </div>
    <div
      ref={mapContainerRef}
      style={{ width: "100%", height: "100vh" }}
    />
    {/*FLOOD ZONE LEGEND - Bottom Center */}
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgba(255, 255, 255, 0.95)",
        padding: "5px 5px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
        fontFamily: "Inter, sans-serif",
        fontSize: "12px",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <span
        style={{
          fontWeight: "600",
          color: "#333",
          fontSize: "13px",
          marginRight: "5px",
        }}
      >
        FloodZone:
      </span>
      {FLOOD_ZONE_LEGEND.map((item) => (
        <div
          key={item.zone}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <div
            style={{
              width: "18px",
              height: "18px",
              backgroundColor: item.color,
               opacity:0.50,
              borderRadius: "3px",
                 border: `2px solid ${item.color}`, 
            }}
          />
          <span style={{ color: "#555", fontSize: "11px", whiteSpace: "nowrap" }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
    </>
  );
};

export default FullParcelComponent;
